 //import {getToken} from "../Utils/Common";

import {getToken} from "../Utils/Common";

//let url = "https://d25c1smh4gyzd4.cloudfront.net/"
let url = process.env.REACT_APP_BACKEND_API_URI


export function getAdvices() {
let link = url + "annotator/get_advices"
    return fetch(link, {
        method: 'POST',
        headers: {
            //'Authorization': getToken(),

            "Content-Type": "application/json"
        },
        body:JSON.stringify({"token":getToken(),"met":"GET"})
    })
        .then(response => response.json())
        .then(res => {return res;})
        .catch((error) => {
            console.error('Error:', error);
        });
}


// Edit one advice in the advices catalogue
export function saveAdvice(data) {
    let link = url + "annotator/create_advice"
    data.token = getToken()
    return fetch(link, {
        method: 'POST',
        headers: {
            //'Authorization': getToken(),
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

// Delete one advice from the advices catalogue
export function deleteAdvice(data) {
    let uid = data['advices'][0]['uidid']
    let link = url + "annotator/delete_advice/"+uid


    return fetch(link, {
        method: 'POST',
        headers: {
            //'Authorization': getToken(),
            "Content-Type": "application/json"
        },
        body:JSON.stringify({"token":getToken(),"del":"del"})
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });
}

// Create a new advice in the advice catalogue
export function saveNewAdvice(data) {
    let link = url + "annotator/create_advice"
    data.token = getToken()
    return fetch(link, {
        method: 'POST',
        headers: {
            //'Authorization': getToken(),
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    }).then(response => response.json())
        .catch((error) => {
            console.error('Error:', error);
        });

}